// @ts-nocheck
// Thin client for the local backend. When the backend isn't running (e.g. the
// public Vercel deploy), every call rejects and the app stays in sim mode.
// NOTE: execution + private-key import live in apiLive.ts, which is imported
// ONLY behind import.meta.env.DEV — so the public bundle ships zero spend/import code.

export type BackendStatus = { ok: boolean; rpc: boolean; rpcHost: string; walletCount: number };
export type RealWallet = { id: string; label: string; publicKey: string; createdAt: string };
export type RealBalance = { id: string; publicKey: string; sol: number; tokens: number };

// `x-lily-app` marks requests as coming from the app; the local backend requires
// it on mutating calls (a cross-origin attacker can't set a custom header without
// a preflight the backend rejects).
export const APP_HEADER = { "x-lily-app": "1" } as const;

export async function j<T>(url: string, init?: RequestInit): Promise<T> {
  const res = await fetch(url, { ...init, headers: { ...APP_HEADER, ...(init?.headers ?? {}) } });
  const ct = res.headers.get("content-type") || "";
  if (!res.ok || !ct.includes("application/json")) throw new Error(`backend ${res.status}`);
  return (await res.json()) as T;
}

export const jsonPost = (body: unknown): RequestInit => ({
  method: "POST",
  headers: { "content-type": "application/json", ...APP_HEADER },
  body: JSON.stringify(body),
});

// Read-only + sim-safe wallet management (no spend, no key import).
export const api = {
  status: () => j<BackendStatus>("/api/status"),
  list: () => j<{ wallets: RealWallet[] }>("/api/wallets"),
  create: (count: number) => j<{ created: RealWallet[] }>("/api/wallets/create", jsonPost({ count })),
  remove: (id: string) =>
    j<{ deleted: number }>("/api/wallets", { method: "DELETE", headers: { "content-type": "application/json" }, body: JSON.stringify({ id }) }),
  balances: (mint?: string) => j<{ balances: RealBalance[] }>(`/api/wallets/balances${mint ? `?mint=${encodeURIComponent(mint)}` : ""}`),
};

export type FundingCheck = { walletId: string; label: string; publicKey?: string; needSol: number; haveSol: number; ok: boolean };
export type AuditResult = {
  mode: "audit";
  ok: boolean;
  devWallet: { id: string; label: string; publicKey: string } | null;
  steps: Array<{ index: number; sendMode: string; label?: string; atomic?: boolean; actions: Array<{ kind: string; wallet: string; sol?: number; pct?: number; sellPct?: number }> }>;
  fundingChecks: FundingCheck[];
  totalNeeded: number;
  fundingOk: boolean;
  errors: string[];
  warnings: string[];
};
export type LiveResult = { mode: "live"; ok: boolean; error?: string; buyFailures?: number; sellFailures?: number; mint: string; launchSignature: string; log: unknown[] };
